import { useRef, useState } from 'react'

export const useRoomAudioRecorder = () => {
  const [audioChunks, setAudioChunks] = useState<Blob[]>([])
  const [file, setFile] = useState<File | null>(null)
  const mediaRecorder = useRef<MediaRecorder | null>(null)
  const stream = useRef<MediaStream | null>(null)

  const mimeType = 'audio/webm'

  const startRecording = async () => {
    const streamSource = await navigator.mediaDevices.getUserMedia({
      audio: true,
    })
    stream.current = streamSource

    const recorder = new MediaRecorder(streamSource, { mimeType })
    mediaRecorder.current = recorder

    const chunks: Blob[] = []
    recorder.ondataavailable = (e) => e.data.size > 0 && chunks.push(e.data)
    recorder.onstop = () => {
      const blob = new Blob(chunks, { type: mimeType })
      const recordedFile = new File([blob], `room-audio-${Date.now()}.webm`, {
        type: mimeType,
      })
      setFile(recordedFile)
      setAudioChunks([])
    }

    recorder.start()
  }

  const stopRecording = () => {
    if (mediaRecorder.current && mediaRecorder.current.state !== 'inactive') {
      mediaRecorder.current.stop()
      stream.current?.getTracks().forEach((track) => track.stop())
    }
  }

  return {
    startRecording,
    stopRecording,
    file,
    setFile,
  }
}
